import type { ShopDto, UpdateShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

type UseUpdateShopParams = {
	onSuccess?: (data: ShopDto) => void;
};

export default function useUpdateShop(
	shopId: string,
	options?: UseUpdateShopParams,
) {
	const invalidateShop = useInvalidateShop(shopId);
	return useApiMutation("patch", "/shops/{shopId}", {
		invalidate: invalidateShop,
		onSuccess: (data: ShopDto) => {
			options?.onSuccess?.(data);
		},
		mapVariables: (requestBody: UpdateShopDto) => ({
			params: { path: { shopId } },
			body: requestBody,
		}),
	});
}
